// Tiny synthesized sounds. No audio files needed.
// Plays after a user gesture so most browsers' autoplay policies are satisfied.

const safe = (fn) => { try { fn(); } catch (_) { /* silent */ } };

const _ctx = () => {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  return new Ctx();
};

const _arpeggio = (notes, gain = 0.14, spacing = 0.11, duration = 0.42) => {
  const ctx = _ctx();
  if (!ctx) return;
  notes.forEach((freq, i) => {
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = "triangle";
    osc.frequency.value = freq;
    const start = ctx.currentTime + i * spacing;
    g.gain.setValueAtTime(0, start);
    g.gain.linearRampToValueAtTime(gain, start + 0.015);
    g.gain.exponentialRampToValueAtTime(0.001, start + duration);
    osc.connect(g);
    g.connect(ctx.destination);
    osc.start(start);
    osc.stop(start + duration + 0.05);
  });
};

// Big celebration, fires when a story submit overlay opens (after confetti)
export const playCelebrationSound = () => {
  safe(() => _arpeggio([523.25, 659.25, 783.99, 1046.5], 0.16, 0.11, 0.55)); // C5 E5 G5 C6
};

// Smaller "you earned points" cue, fires when dashboard detects new points
export const playPointsSound = () => {
  safe(() => _arpeggio([659.25, 987.77], 0.13, 0.09, 0.35)); // E5 B5, quick double tap
};
